import React, { useState, useCallback, useRef } from "react";
import Cropper from "react-easy-crop";
import { useDropzone } from "react-dropzone";
import Spinner from "../../../../common/spinner";
import Toast from "../../../../common/toast";

const UploadProfilePopup = ({ isLoading, setIsLoading, handleUpload }) => {
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropAreaPixels, setCropAreaPixels] = useState(null);
  const modalRef = useRef(null);

  const getCroppedImg = (imageSrc, cropAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = cropAreaPixels.width;
        canvas.height = cropAreaPixels.height;

        ctx.drawImage(
          image,
          cropAreaPixels.x,
          cropAreaPixels.y,
          cropAreaPixels.width,
          cropAreaPixels.height,
          0,
          0,
          cropAreaPixels.width,
          cropAreaPixels.height
        );

        canvas.toBlob((blob) => resolve(blob), "image/jpeg");
      };
      image.onerror = reject;
    });
  };

  // Handle drag & drop
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
  });

  // Capture crop area
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCropAreaPixels(croppedAreaPixels);
  }, []);

  // Save Cropped Image
  const saveCroppedImage = async () => {
    if (!image || !cropAreaPixels) return;

    setIsLoading(true);
    const croppedBlob = await getCroppedImg(image, cropAreaPixels);
    const croppedFile = new File([croppedBlob], "cropped-image.jpg", {
      type: "image/jpeg",
    });
    const uploadImageRes = await handleUpload(croppedFile);
    if (uploadImageRes) {
      setImage(null);
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.click();
        }
      }, 2000);
    }
  };

  return (
    <div
      className="modal fade twm-sign-up"
      id="upload_profile_popup"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel2"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title" id="sign_up_popupLabel2">
              Upload Image
            </h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={modalRef}
            />
          </div>
          <div className="modal-body">
            {!image && (
              <div {...getRootProps()} className="drag-drop-area">
                <input {...getInputProps()} />
                <p>Drag & drop an image here or click to upload</p>
              </div>
            )}

            {/* Image Cropper */}
            {image && (
              <div className="cropper-container">
                <button className="close-btn" onClick={() => setImage(null)}>
                  ✖
                </button>
                <Cropper
                  image={image}
                  crop={crop}
                  zoom={zoom}
                  aspect={1} // Adjust aspect ratio if needed
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />

                {/* Zoom Controls */}
                <div className="zoom-controls">
                  <i className="fas fa-image"></i> {/* Small image icon */}
                  <input
                    type="range"
                    min="1"
                    max="3"
                    step="0.1"
                    value={zoom}
                    onChange={(e) => setZoom(e.target.value)}
                  />
                  <i className="fas fa-images"></i> {/* Large image icon */}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button> */}
            <button
              type="button"
              id="deleteConfirmationModal"
              className="btn btn-primary"
              onClick={saveCroppedImage}
              disabled={!image}
            >
              {isLoading ? <Spinner /> : "Save"}
            </button>
            {/* </>
            )} */}
          </div>
        </div>
      </div>
      {/* {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""} */}
    </div>
  );
};

export default UploadProfilePopup;
